import { PureComponent, ReactElement } from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import { Layout } from 'antd';
import { ApiItem } from './Apis/ApiItem/ApiItem';
import { ApiKeys } from './Apis/ApiKeys/ApiKeys';
import { Apis } from './Apis/Apis';
import { Authentications } from './Authentications/Authentications';
import { Accounts } from './Accounts/Accounts';
import { AccountItem } from './Accounts/AccountItem/AccountItem';
import { DatasetItem } from './Datasets/DatasetItem/DatasetItem';
import { Queries } from './Datasets/Datasets';
import { Executions } from './Monitor/Executions/Executions';
import { Explorer } from './Explorer/Explorer';
import { ModelItem } from './Models/ModelItem/ModelItem';
import { Models } from './Models/Models';
import { Monitor } from './Monitor/Monitor';
import { NavBar } from './NavBar/NavBar';
import { PageNotFound } from 'containers/Components/PageNotFound/PageNotFound';
import { Splash } from './Splash/Splash';
import { Groups } from './Groups/Groups';
import { Workflows } from './Workflows/Workflows';
import { RouteBuilder } from 'utils/RouteBuilder';
import { WorkflowItem } from './Workflows/WorkflowItem/WorkflowItem';
import { Dashboards } from './Dashboards/Dashboards';
import { DashboardItem } from './Dashboards/DashboardItem/DashboardItem';
import { ModelProvider } from 'context/ModelContext';
import { EntityContext } from 'context/EntityContext';
import { GroupItem } from './Groups/GroupItem/GroupItem';
import { Packs } from './Packs/Packs';
import { StatusType } from 'constants/StatusType';
//import { Applications } from './Applications_REMOVE/Applications';
import { Notifications } from './Notifications/Notifications';
import { Alerts } from './Notifications/Alerts/Alerts';
import authService from 'services/AuthService';
import entityService from 'services/EntityService';
import serviceWarmer from 'utils/ServiceWarmer';
import './Console.less';

export type ConsoleState = {
    status: StatusType,
    collapsed: boolean
}

export type ConsoleProps = RouteComponentProps & {
}

export class Console extends PureComponent<ConsoleProps, ConsoleState> {

    static contextType = EntityContext;

    constructor(props: ConsoleProps) {
        super(props);
        this.state = {
            status: StatusType.INIT,
            collapsed: false
        };
        this.handleToggleMenu = this.handleToggleMenu.bind(this);
    }

    private handleToggleMenu(): void {
        this.setState({ collapsed: !this.state.collapsed });
    }

    private readPermissionsRequest(): Promise<any> {
        const request = {};
        return entityService.readPermissions(request,
            (response: any) => this.readPermissionsResponse(response),
            (response: any) => this.readPermissionsException(response),
            true
        );
    }

    private readPermissionsResponse(response: any): void {
        const permissions = response.data.permissions;
        this.context.savePermissions(permissions);
        this.setState({status: StatusType.READY});
    }

    private readPermissionsException(response: any): void {
        this.setState({status: StatusType.FAILED});
    }

    public componentWillUnmount(): void {
        serviceWarmer.stop();
    }

    public componentDidMount(): void {
        serviceWarmer.start();
        if (!this.context.user) {
            // If the page got refreshed, may need to reset the user.
            authService.readUser().then(user => {
                this.context.saveUser(user);
                this.readPermissionsRequest();
            }).catch(e => {
                this.context.clearUser();
                this.props.history.push(RouteBuilder.USER_LOGIN);
                //this.props.history.push(RouteBuilder.user(this.props, RouteBuilder.USER_LOGIN));
            });
        } else {
            this.setState({status: StatusType.READY});
        }
    }    

    public render(): ReactElement {
        if (this.state.status === StatusType.READY) {
            return (
                <ModelProvider>
                    <Layout className="x-console">
                        <Layout.Header className="x-console-header">
                            <NavBar {...this.props} onToggleMenu={this.handleToggleMenu} />
                        </Layout.Header>
                        <Layout>
                            <Layout.Sider className="x-console-sidebar" width={300} collapsible trigger={null} collapsed={this.state.collapsed}>
                                <Route render={(props) => <Explorer {...props} />} />
                            </Layout.Sider>
                            <Layout.Content className="x-console-body">
                                <Switch>
                                    <Route exact path={RouteBuilder.CONSOLE} component={Splash} />
                                    <Route exact path={RouteBuilder.CONSOLE_GROUPS} component={Groups} />
                                    <Route exact path={RouteBuilder.CONSOLE_GROUP} component={GroupItem} />
                                    <Route exact path={RouteBuilder.CONSOLE_CREDENTIALS} component={Authentications} />
                                    <Route exact path={RouteBuilder.CONSOLE_ACCOUNTS} component={Accounts} />
                                    <Route path={RouteBuilder.CONSOLE_ACCOUNT} component={AccountItem} />
                                    <Route exact path={RouteBuilder.CONSOLE_DATASETS} component={Queries} />
                                    <Route path={RouteBuilder.CONSOLE_DATASET} component={DatasetItem} />
                                    <Route exact path={RouteBuilder.CONSOLE_WORKFLOWS} component={Workflows} />
                                    <Route path={RouteBuilder.CONSOLE_WORKFLOW} component={WorkflowItem} />
                                    <Route exact path={RouteBuilder.CONSOLE_API_KEYS} component={ApiKeys} />
                                    <Route exact path={RouteBuilder.CONSOLE_APIS} component={Apis} />
                                    <Route path={RouteBuilder.CONSOLE_API} component={ApiItem} />
                                    {/* <Route exact path={RouteBuilder.CONSOLE_APPLICATIONS} component={Applications} /> */}
                                    <Route exact path={RouteBuilder.CONSOLE_MONITOR} component={Monitor} />
                                    <Route path={RouteBuilder.CONSOLE_EXECUTIONS} component={Executions} />
                                    <Route exact path={RouteBuilder.CONSOLE_MODELS} component={Models} />
                                    <Route path={RouteBuilder.CONSOLE_MODEL} component={ModelItem} />
                                    <Route exact path={RouteBuilder.CONSOLE_DASHBOARDS} component={Dashboards} />
                                    <Route exact path={RouteBuilder.CONSOLE_DASHBOARD} component={DashboardItem} />
                                    <Route exact path={RouteBuilder.CONSOLE_NOTIFICATIONS} component={Notifications} />
                                    <Route exact path={RouteBuilder.CONSOLE_ALERTS} component={Alerts} />
                                    <Route exact path={RouteBuilder.CONSOLE_PACKAGES} component={Packs} />
                                    <Route component={PageNotFound} />
                                </Switch>
                            </Layout.Content>
                        </Layout>
                    </Layout>
                </ModelProvider>
            );
        } else {
            // Setting up user.
            // TODO: spinner
            return <></>;
        }
    }

}
